import styled from 'styled-components';
import {
  screenSize,
  whiteColor,
  inputBorderColor,
  mediumFont,
  primaryColor,
} from '@app/styles';

type ButtonProps = {
  size?: string;
};

export const TextAreaContainer = styled.div`
  position: relative;
`;
export const TextAreaComponent = styled.textarea`
  width: 100%;
  min-height: 86px;
  max-height:200px;
  line-height: 20px;
  margin-bottom: 18px;
  margin-top: 5px;
  padding: 12px 12px;
  border: 1px solid ${inputBorderColor};
  border-radius: 3px;
  color: #2d3448;
  box-shadow: none;
  outline: none;
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-webkit-resizer {
    display: none;
  }
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
   ${({ size }: ButtonProps) => {
     if (size) {
       return `
                min-height: ${size};
               
            `;
     }
   }}
  @media (${screenSize.tablet}) {
    background-color: #fafbfc;
    border-color: ${inputBorderColor};
    &:disabled {
      background-color: ${whiteColor};
      color: grey;
      cursor: not-allowed;
      border-color: ${inputBorderColor};
      &:hover {
        background-color: ${whiteColor};
        border-color: ${inputBorderColor};
        color: grey;
      }
      &:active,
      &:focus {
        background-color: ${whiteColor};
        border-color: ${inputBorderColor};
      }
    }
    &:hover {
      background-color: ${whiteColor};
      border-color: ${primaryColor};
    }
    &:active,
    &:focus {
      background-color: ${whiteColor};
      border-color: ${primaryColor};
    }
  }
`;
export const Label = styled.label`
  font-size: 15px;
  color: #0f1d2a;
  opacity: 0.5;
  text-align: left;
  line-height: 21px;
  ${mediumFont}
`;
